import { render } from "./TopbarMenu.vue?vue&type=template&id=bf994df0&scoped=true"
import script from "./TopbarMenu.vue?vue&type=script&lang=js"
export * from "./TopbarMenu.vue?vue&type=script&lang=js"

import "./TopbarMenu.vue?vue&type=style&index=0&id=bf994df0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf994df0"]])

export default __exports__